<template>
  <div><AnnouncementView :is-view="false" /></div>
</template>

<script>
import AnnouncementView from './components/AnnouncementView.vue';

export default {
  components: { AnnouncementView },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
